import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  getCurrentPosition(): Promise<Coordinates> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported by this browser.'));
        return;
      }

      let isRejected = false;

      const timeoutId = setTimeout(() => {
        isRejected = true;
        reject(new Error('Geolocation request timed out.'));
      }, 5000);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          clearTimeout(timeoutId);
          if (!isRejected) {
            resolve(position.coords);
          }
        },
        (error) => {
          clearTimeout(timeoutId);
          reject(new Error(this.getErrorMessage(error)));
        }
      );
    });
  }

  private getErrorMessage(error: GeolocationPositionError): string {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return 'Geolocation permission denied.';
      case error.POSITION_UNAVAILABLE:
        return 'Geolocation position unavailable.';
      case error.TIMEOUT:
        return 'Geolocation request timed out.';
      default:
        return 'An unknown error occurred.';
    }
  }
}

interface Coordinates {
  readonly latitude: number;
  readonly longitude: number;
  readonly altitude?: number;
  readonly accuracy: number;
  readonly altitudeAccuracy?: number;
  readonly heading?: number;
  readonly speed?: number;
}
